export const myAccountConfig = {
  company: 'Lloyds',
  referenceName: 'a Lloyds',
  seoTitleSuffix: '| My Account | Lloyds Pet Insurance',
  petReferenceName: 'Pet',
  enableMarketingMaterials: false,
  termsReferenceName: 'Policy Booklet',
  showAddPetCard: false,
  marketingReferenceName: 'marketing choices',
  paymentDetailSupportMessage: true,
  enableUpdateMarketingPreferences: false,
  agriaAppReferenceName: 'Access to a vet 24/7',
  logoutRedirectUrl: '/my-account/login/',
} as const;
